import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function AboutUs() {
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #FDFCFE 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk1.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    🎓 ABOUT DTK COLLEGE
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  About Us
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  25 years of excellence in education and training
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        <section id="about-us" className="about-us section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            {/* DTK Section */}
            <div className="row gy-4 align-items-center mb-5">
              <div className="col-lg-5">
                <div className="about-image" style={{ position: 'relative' }}>
                  <div style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '-20px',
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                    borderRadius: '24px',
                    zIndex: 0,
                    opacity: 0.1
                  }}></div>
                  <img src="/assets/img/dtk1.jpg" alt="DTK College" className="img-fluid shadow-lg" style={{ 
                    borderRadius: '24px',
                    position: 'relative',
                    zIndex: 1,
                    border: '4px solid white'
                  }} />
                </div>
              </div>
              
              <div className="col-lg-7">
                <div className="about-content">
                  <div style={{
                    display: 'inline-block',
                    backgroundColor: '#F5EBFA',
                    color: '#7B3F9E',
                    padding: '8px 20px',
                    borderRadius: '50px',
                    marginBottom: '25px',
                    border: '2px solid #D4BFE3',
                    fontSize: '0.9rem',
                    fontWeight: '600'
                  }}>
                    🎉 CELEBRATING 25 YEARS
                  </div>
                  
                  <h2 className="mb-4" style={{
                    fontSize: '2.5rem',
                    fontWeight: '700',
                    color: '#1e293b',
                    letterSpacing: '-0.5px'
                  }}>
                    DTK <span style={{ color: '#7B3F9E' }}>College</span>
                  </h2>
                  
                  <p style={{ 
                    fontSize: '1.05rem', 
                    lineHeight: '1.8', 
                    color: '#475569',
                    marginBottom: '20px'
                  }}>
                    DTK celebrates over two decades of developing and training learners from the UK and around the world at its former Plaistow and current Stratford base.
                  </p>
                  
                  <p style={{ 
                    fontSize: '1.05rem', 
                    lineHeight: '1.8', 
                    color: '#475569',
                    marginBottom: '20px'
                  }}>
                    DTK welcomes working and partnering with FE Colleges, training providers and client organisations in transforming learning, knowledge and development in East London and nationwide.
                  </p>
                  
                  <p style={{ 
                    fontSize: '1.05rem', 
                    lineHeight: '1.8', 
                    color: '#475569',
                    marginBottom: 0
                  }}>
                    DTK continues to be a platform for many exciting developments in a changing Education sector that will lead us and our client groups into a successful future.
                  </p>
                </div>
              </div>
            </div>

            {/* Why study at DTK Section */}
            <div className="row mt-5 pt-5">
              <div className="col-lg-12 text-center mb-5">
                <div style={{
                  display: 'inline-block',
                  backgroundColor: '#F5EBFA',
                  color: '#7B3F9E',
                  padding: '8px 20px',
                  borderRadius: '50px',
                  marginBottom: '20px',
                  border: '2px solid #D4BFE3',
                  fontSize: '0.9rem',
                  fontWeight: '600'
                }}>
                  ✨ WHY CHOOSE US
                </div>
                <h2 style={{
                  fontSize: '2.5rem',
                  fontWeight: '700',
                  color: '#1e293b',
                  letterSpacing: '-0.5px'
                }}>
                  Why study at <span style={{ color: '#7B3F9E' }}>DTK</span>?
                </h2>
              </div>
            </div>

            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="accordion" id="whyStudyAccordion">
                  {/* Learner Success & Tradition */}
                  <div className="accordion-item mb-3" style={{ 
                    border: '2px solid #e2e8f0', 
                    backgroundColor: 'white', 
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}>
                    <h2 className="accordion-header">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={{ 
                        backgroundColor: '#f8fafc', 
                        border: 'none', 
                        boxShadow: 'none',
                        padding: '20px 25px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#1e293b'
                      }}>
                        <span style={{ 
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          marginRight: '15px',
                          border: '2px solid #7B3F9E',
                          fontSize: '1.2rem'
                        }}>🏆</span>
                        Learner Success & Tradition
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#whyStudyAccordion">
                      <div className="accordion-body" style={{ 
                        padding: '25px',
                        fontSize: '1.05rem',
                        lineHeight: '1.8',
                        color: '#475569',
                        backgroundColor: 'white'
                      }}>
                        Our learners on successful completion of their courses and training have progressed to improved life skills, further training and better employment. The college has been training adult learners and latterly apprentices since 1999.
                      </div>
                    </div>
                  </div>

                  {/* High Quality Courses */}
                  <div className="accordion-item mb-3" style={{ 
                    border: '2px solid #e2e8f0', 
                    backgroundColor: 'white', 
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}>
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={{ 
                        backgroundColor: '#f8fafc', 
                        border: 'none', 
                        boxShadow: 'none',
                        padding: '20px 25px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#1e293b'
                      }}>
                        <span style={{ 
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          marginRight: '15px',
                          border: '2px solid #7B3F9E',
                          fontSize: '1.2rem'
                        }}>📚</span>
                        High Quality Courses
                      </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#whyStudyAccordion">
                      <div className="accordion-body" style={{ 
                        padding: '25px',
                        fontSize: '1.05rem',
                        lineHeight: '1.8',
                        color: '#475569',
                        backgroundColor: 'white'
                      }}>
                        DTK is one of the best colleges in the UK. Our courses are accredited by leading UK Awarding bodies e.g. OCR, NCFE, BCS, and Pearson Edexcel.  The Quality Assurance of our education provision is reviewed regularly and the quality of our courses and the good practice are evident.
                      </div>
                    </div>
                  </div>

                  {/* Location */}
                  <div className="accordion-item mb-3" style={{ 
                    border: '2px solid #e2e8f0', 
                    backgroundColor: 'white', 
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}>
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={{ 
                        backgroundColor: '#f8fafc', 
                        border: 'none', 
                        boxShadow: 'none',
                        padding: '20px 25px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#1e293b'
                      }}>
                        <span style={{ 
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          marginRight: '15px',
                          border: '2px solid #7B3F9E',
                          fontSize: '1.2rem'
                        }}>📍</span>
                        Location
                      </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#whyStudyAccordion">
                      <div className="accordion-body" style={{ 
                        padding: '25px',
                        fontSize: '1.05rem',
                        lineHeight: '1.8',
                        color: '#475569',
                        backgroundColor: 'white'
                      }}>
                        Our location is five minutes from the well-connected Stratford station and Westfield Shopping Centre, close to the Olympic Stadium. We are in well-appointed contemporary premises set in the lovely environs of Stratford, opposite the University of East London, Romford Road campus.
                      </div>
                    </div>
                  </div>

                  {/* Friendly Staff & Students */}
                  <div className="accordion-item mb-3" style={{ 
                    border: '2px solid #e2e8f0', 
                    backgroundColor: 'white', 
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}>
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour" style={{ 
                        backgroundColor: '#f8fafc', 
                        border: 'none', 
                        boxShadow: 'none',
                        padding: '20px 25px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#1e293b'
                      }}>
                        <span style={{ 
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          marginRight: '15px',
                          border: '2px solid #7B3F9E',
                          fontSize: '1.2rem'
                        }}>👥</span>
                        Friendly Staff & Students
                      </button>
                    </h2>
                    <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#whyStudyAccordion">
                      <div className="accordion-body" style={{ 
                        padding: '25px',
                        fontSize: '1.05rem',
                        lineHeight: '1.8',
                        color: '#475569',
                        backgroundColor: 'white'
                      }}>
                        Our welcoming staff and students make you feel at ease. We are very happy with the level of individual support and attention we give to our students. Our class sizes are kept small so that you receive high levels of contact time and learning.
                      </div>
                    </div>
                  </div>

                  {/* Support Services */}
                  <div className="accordion-item mb-3" style={{ 
                    border: '2px solid #e2e8f0', 
                    backgroundColor: 'white', 
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}>
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive" style={{ 
                        backgroundColor: '#f8fafc', 
                        border: 'none', 
                        boxShadow: 'none',
                        padding: '20px 25px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#1e293b'
                      }}>
                        <span style={{ 
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          marginRight: '15px',
                          border: '2px solid #7B3F9E',
                          fontSize: '1.2rem'
                        }}>🤝</span>
                        Support Services
                      </button>
                    </h2>
                    <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#whyStudyAccordion">
                      <div className="accordion-body" style={{ 
                        padding: '25px',
                        fontSize: '1.05rem',
                        lineHeight: '1.8',
                        color: '#475569',
                        backgroundColor: 'white'
                      }}>
                        All students have direct access to a college tutor and the Director of Studies, and the additional advice, guidance and support provided by the Student Affairs Department.
                      </div>
                    </div>
                  </div>

                  {/* Affordability */}
                  <div className="accordion-item mb-3" style={{ 
                    border: '2px solid #e2e8f0', 
                    backgroundColor: 'white', 
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}>
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix" style={{ 
                        backgroundColor: '#f8fafc', 
                        border: 'none', 
                        boxShadow: 'none',
                        padding: '20px 25px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#1e293b'
                      }}>
                        <span style={{ 
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          marginRight: '15px',
                          border: '2px solid #7B3F9E',
                          fontSize: '1.2rem'
                        }}>💰</span>
                        Affordability
                      </button>
                    </h2>
                    <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#whyStudyAccordion">
                      <div className="accordion-body" style={{ 
                        padding: '25px',
                        fontSize: '1.05rem',
                        lineHeight: '1.8',
                        color: '#475569',
                        backgroundColor: 'white'
                      }}>
                        Our fees at DTK are highly competitive. Most courses are funded so you have little or nothing to pay. Check your eligibility with Students Affairs Department.
                      </div>
                    </div>
                  </div>

                  {/* State of the Art Facilities */}
                  <div className="accordion-item mb-3" style={{ 
                    border: '2px solid #e2e8f0', 
                    backgroundColor: 'white', 
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                  }}>
                    <h2 className="accordion-header">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven" style={{ 
                        backgroundColor: '#f8fafc', 
                        border: 'none', 
                        boxShadow: 'none',
                        padding: '20px 25px',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#1e293b'
                      }}>
                        <span style={{ 
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          marginRight: '15px',
                          border: '2px solid #7B3F9E',
                          fontSize: '1.2rem'
                        }}>🏢</span>
                        State of the Art Facilities
                      </button>
                    </h2>
                    <div id="collapseSeven" className="accordion-collapse collapse" data-bs-parent="#whyStudyAccordion">
                      <div className="accordion-body" style={{ 
                        padding: '25px',
                        fontSize: '1.05rem',
                        lineHeight: '1.8',
                        color: '#475569',
                        backgroundColor: 'white'
                      }}>
                        We offer contemporary facilities and the latest technology and resources to make your learning time with us successful.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="row mt-5 py-5" data-aos="fade-up">
              <div className="col-lg-12">
                <div className="shadow-lg" style={{
                  background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
                  borderRadius: '24px',
                  padding: '60px 50px',
                  textAlign: 'center',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  {/* Background Pattern */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
                    backgroundSize: '80px 80px',
                    backgroundRepeat: 'repeat'
                  }}></div>
                  
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <div style={{
                      width: '100px',
                      height: '100px',
                      backgroundColor: 'rgba(123, 63, 158, 0.2)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 30px',
                      border: '3px solid rgba(123, 63, 158, 0.5)'
                    }}>
                      <span style={{ fontSize: '3rem' }}>✈️</span>
                    </div>
                    
                    <h2 className="mb-4" style={{
                      fontSize: '2.5rem',
                      fontWeight: '700',
                      color: 'white',
                      letterSpacing: '-0.5px'
                    }}>
                      Let your dreams take a flight!
                    </h2>
                    
                    <p style={{
                      fontSize: '1.1rem',
                      color: 'rgba(255,255,255,0.8)',
                      marginBottom: '30px',
                      maxWidth: '600px',
                      margin: '0 auto 30px'
                    }}>
                      Start your journey with DTK College today and achieve your educational goals
                    </p>
                    
                    <Link to="/contact" className="btn btn-lg" style={{
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      color: 'white',
                      border: 'none',
                      padding: '16px 50px',
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      borderRadius: '50px',
                      boxShadow: '0 8px 20px rgba(123, 63, 158, 0.4)',
                      transition: 'all 0.3s ease',
                      textDecoration: 'none',
                      display: 'inline-block'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 12px 30px rgba(123, 63, 158, 0.5)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(123, 63, 158, 0.4)';
                    }}>
                      Contact us today <i className="bi bi-arrow-right ms-2"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default AboutUs;